import moment from 'moment';

const operator = ['less_than', 'greater_than', 'less_or_equal', 'greater_or_equal'];

const days = [...Array(7).keys()].map((value) => ({
  value: value + 1,
  label: moment()
    .isoWeekday(value + 1)
    .format('dddd'),
}));
const timeFrames = [
  {
    value: 'hourly',
    label: 'HOURLY',
  },
  {
    value: 'daily',
    label: 'DAILY',
  },
  {
    value: 'weekly',
    label: 'WEEKLY',
  },
  {
    value: 'monthly',
    label: 'MONTHLY',
  },
];
const hours_by_frame = { hourly: 1, daily: 24, weekly: 168, monthly: 720 };

export { days, operator, timeFrames, hours_by_frame };
